import React, { useEffect, useState } from "react";
import { client, formatApiError } from "@/lib/api";
import { DynamicForm } from "@/admin/DynamicForm";
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";

export const SingletonForm = ({ endpoint, config }) => {
  const [values, setValues] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    client.get(`/admin/${endpoint}`)
      .then(({ data }) => setValues(data))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, [endpoint]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await client.put(`/admin/${endpoint}`, values);
      setValues(data);
      toast.success("Saved. Changes are live on the public site.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  if (!values) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-brand-orange" /></div>;

  return (
    <div className="max-w-4xl">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-navy">{config.title}</h1>
        <Button onClick={save} disabled={saving} data-testid="save-singleton-btn" className="rounded-sm bg-brand-orange hover:bg-brand-orange-600">
          {saving ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Save className="mr-1 h-4 w-4" />} Save Changes
        </Button>
      </div>
      <div className="rounded-sm border border-border bg-white p-6">
        <DynamicForm fields={config.fields} values={values} onChange={(k, v) => setValues((s) => ({ ...s, [k]: v }))} />
      </div>
    </div>
  );
};

export default SingletonForm;
